function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 30,
  fill: "#D7F6EE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39.2 38.3925C39.2 39.1424 38.5939 39.7503 37.8462 39.7503H22.9539C22.2062 39.7503 21.6001 39.1424 21.6001 38.3925V20.7414C21.6001 19.9916 22.2062 19.3837 22.9539 19.3837H32.5472C32.9061 19.3837 33.2502 19.5267 33.504 19.781L38.8038 25.0963C39.0574 25.3508 39.1999 25.6959 39.2 26.0558V38.3925Z",
  stroke: "#4C4C4C",
  strokeWidth: 1.7,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M39.1999 26.1725H33.7845C33.0368 26.1725 32.4307 25.5646 32.4307 24.8148V19.3837",
  stroke: "#4C4C4C",
  strokeWidth: 1.7,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M25.2002 31.4186H35.6002",
  stroke: "#4C4C4C",
  strokeWidth: 1.7,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M25.2002 35.5536H35.6002",
  stroke: "#4C4C4C",
  strokeWidth: 1.7,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M29.5998 23.6197V22.593H27.2821V23.6064H27.6436L26.9279 24.4429H26.6315V23.6064H27.039V22.593H26.4892V22.9734H26.1913V22.593H25.6475V22.9734H25.3496V22.593H24.7998V23.6197H25.2859V24.8976V26.1754H24.7998V27.2021H27.039V26.1888H26.6315V25.3522H26.9279L27.6436 26.1888H27.2821V27.2021H29.5998V26.1754H29.2397L28.1475 24.8976L29.2397 23.6197H29.5998Z",
  fill: "#4C4C4C"
});

const SvgGrantContextIcon = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "grant-context-icon",
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGrantContextIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/grant-context-icon.b68ba0a8.svg";
export { ForwardRef as ReactComponent };